import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderView.';
  public static readonly purchaseOrderDictionaryName = `${Id.prefix}purchaseOrderDictionaryName`;
  public static readonly detailsTabTitle = `${Id.prefix}detailsTabTitle`;
  public static readonly cancelButton = `${Id.prefix}cancelButton`;
  public static readonly issueButton = `${Id.prefix}issueButton`;
  public static readonly completeButton = `${Id.prefix}completeButton`;
  public static readonly saveButton = `${Id.prefix}saveButton`;
  public static readonly validateButton = `${Id.prefix}validateButton`;
  public static readonly statusButton = `${Id.prefix}statusButton`;
  public static readonly finalStateReasonErrors = `${Id.prefix}finalStateReasonErrors`;
  public static readonly finalStateReasonDeadline = `${Id.prefix}finalStateReasonDeadline`;
  public static readonly finalStateReasonOther = `${Id.prefix}finalStateReasonOther`;
}

export class LangPurchaseOrderView {
  private constructor() {}

  public static purchaseOrderDictionaryName(): string {
    return interpolate(Id.purchaseOrderDictionaryName);
  }

  public static detailsTabTitle(): string {
    return interpolate(Id.detailsTabTitle);
  }

  public static cancelButton(): string {
    return interpolate(Id.cancelButton);
  }

  public static issueButton(): string {
    return interpolate(Id.issueButton);
  }

  public static completeButton(): string {
    return interpolate(Id.completeButton);
  }

  public static saveButton(): string {
    return interpolate(Id.saveButton);
  }

  public static validateButton(): string {
    return interpolate(Id.validateButton);
  }

  public static statusButton(): string {
    return interpolate(Id.statusButton);
  }

  public static finalStateReasonErrors(): string {
    return interpolate(Id.finalStateReasonErrors);
  }

  public static finalStateReasonDeadline(): string {
    return interpolate(Id.finalStateReasonDeadline);
  }

  public static finalStateReasonOther(): string {
    return interpolate(Id.finalStateReasonOther);
  }
}

export class PurchaseOrderViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.purchaseOrderDictionaryName, "{{glossary 'purchase-order'}}", 'Dictionary name for purchase order');
    register.add(Id.detailsTabTitle, 'Details', 'Tab title for details');
    register.add(Id.cancelButton, 'Cancel', 'Button text for cancel');
    register.add(Id.issueButton, 'Issue', 'Button text for issue');
    register.add(Id.completeButton, 'Complete', 'Button text for complete');
    register.add(Id.saveButton, 'Save', 'Button text for save');
    register.add(Id.validateButton, 'Validate', 'Button text for validate');
    register.add(Id.statusButton, 'Status', 'Button text for status');
    register.add(Id.finalStateReasonErrors, 'Error(s)', 'Final state reason: Errors');
    register.add(Id.finalStateReasonDeadline, 'Deadline', 'Final state reason: Deadline');
    register.add(Id.finalStateReasonOther, 'Other', 'Final state reason: Other');
  }
}
